import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingSearch'), ...new Mutations('jobListingSearches') };
